import {
    fetchDomainBranding,
    fetchDomainBrandingLogoUrls,
    setDefaultBrandingData,
} from 'flow/actions/brandingV2-actions';
import MeetingMain from 'flow/components/meeting/shared/MeetingMain';
import { setTitleAndFavIcon } from 'flow/utils/app-utils';
import { useEffect, useState } from 'react';

const MeetingMainUnauthorized = () => {
    const [fetchedBranding, setFetchedBranding] = useState(false);

    useEffect(() => {
        setDefaultBrandingData();
        Promise.all([
            fetchDomainBranding(),
            fetchDomainBrandingLogoUrls(),
        ]).then(() => {
            setFetchedBranding(true);
            setTitleAndFavIcon();
        });
    }, []);

    return fetchedBranding ? <MeetingMain /> : null;
};

export default MeetingMainUnauthorized;
